// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pay-button {\r\n  text-align: center;\r\n}\r\n\r\n.edit-amount-cell {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.edit-icon {\r\n  cursor: pointer;\r\n}\r\n\r\n.input-filter {\r\n  background: 'none';\r\n  font-size: '14px';\r\n}\r\n", ""]);
